import React from 'react';
import LinkButton from '../../../../../../Components/Button/LinkButton';
import { Theme } from '../../../../../../Enums/Theme.enum';
import { useDisclose } from '../../../../../Modal/Hooks/useDisclose';
import ManagerInsuranceCompaniesBatchDownload from '../ManagerInsuranceCompaniesBatchesList/ManagerInsuranceCompaniesBatchDownload';
import ManagerInsuranceCompaniesBatchInvoiceModal from '../ManagerInsuranceCompaniesBatchInvoice/ManagerInsuranceCompaniesBatchInvoiceModal';
import { InsuranceCompanyBatch } from '../../../../Consts/InsuranceCompanyBatchesDefaultColumns.const';
import { INSURANCE_COMPANY_BATCH_TYPE_INVOICE } from '../../../../Consts/InsuranceCompanyBatchType.const';
import {
	CreateInvoiceInsuranceCompanyBatchMutation,
	InsuranceCompanyBatchStatus,
} from '../../../../../../graphql/graphql';

type InvoiceBatch =
	CreateInvoiceInsuranceCompanyBatchMutation['createInvoiceInsuranceCompanyBatch'];

interface Props {
	batch: InsuranceCompanyBatch;
	onInvoiceCreated?: (invoiceBatch: InvoiceBatch) => void;
}

const ManagerInsuranceCompaniesBatchInvoiceAction = ({
	batch,
	onInvoiceCreated,
}: Props) => {
	const { isOpen, onOpen, onClose } = useDisclose();

	if (batch.dtyp === INSURANCE_COMPANY_BATCH_TYPE_INVOICE) {
		return null;
	}

	const hasChildInvoiceBatch = Boolean(batch.childInvoiceBatch);
	const hasInvoiceFile = Boolean(batch.childInvoiceBatch?.file);

	if (hasChildInvoiceBatch && hasInvoiceFile) {
		return (
			<ManagerInsuranceCompaniesBatchDownload
				file={batch.childInvoiceBatch!.file}
				title='component.insuranceCompanyBatch.table.downloadInvoice'
			/>
		);
	}

	if (hasChildInvoiceBatch) {
		return (
			<LinkButton
				title='component.insuranceCompanyBatch.table.createInvoice'
				theme={Theme.BLUE}
				disabled
			/>
		);
	}

	if (
		batch.batchStatus === InsuranceCompanyBatchStatus.Failed ||
		batch.batchStatus === InsuranceCompanyBatchStatus.Rejected
	) {
		return null;
	}

	const handleSuccess = (invoiceBatch: InvoiceBatch) => {
		onInvoiceCreated?.(invoiceBatch);
		onClose();
	};

	return (
		<>
			<LinkButton
				title='component.insuranceCompanyBatch.table.createInvoice'
				theme={Theme.BLUE}
				onClick={onOpen}
			/>
			{isOpen && (
				<ManagerInsuranceCompaniesBatchInvoiceModal
					isOpen
					batchId={batch.id}
					onSuccess={handleSuccess}
					onClose={onClose}
				/>
			)}
		</>
	);
};

export default ManagerInsuranceCompaniesBatchInvoiceAction;
